import { CandidateEmailCorrespondence } from 'services/candidate/types';
import { TabsValue } from '../constants';
import { Conversation } from 'services/conversations/types';

export const getCandidateDrawerTabs = ({
  emailCorrespondences,
  conversation
}: {
  emailCorrespondences: CandidateEmailCorrespondence[] | undefined | null;
  conversation: Conversation | undefined | null;
}) => {
  let tabs = [
    {
      label: 'Analysis',
      value: TabsValue.Analysis
    },
    {
      label: 'Conversation',
      value: TabsValue.Campaign
    },
    {
      label: 'Meeting notes',
      value: TabsValue.MeetingNotes
    },
    {
      label: 'Rejection',
      value: TabsValue.Email
    },
    {
      label: 'Notes',
      value: TabsValue.Notes
    }
  ];

  if (!conversation?.id) {
    tabs = tabs.filter((tab) => tab.value !== TabsValue.Campaign);
  }

  if (!conversation?.calendarBookingId) {
    tabs = tabs.filter((tab) => tab.value !== TabsValue.MeetingNotes);
  }

  if (!emailCorrespondences?.length) {
    tabs = tabs.filter((tab) => tab.value !== TabsValue.Email);
  }

  return tabs;
};
